import { EnhancedListView } from './EnhancedListView'
import { DayFlowView } from './DayFlowView'
import { GanttView } from './GanttView'
import type { ScheduleItem } from './useTodayBoardData'
import type { MovementCallbacks } from './types'

export type ViewMode = 'list' | 'dayflow' | 'gantt'

interface MovementsAreaProps extends MovementCallbacks {
  arriving: ScheduleItem[]
  departing: ScheduleItem[]
  movements: ScheduleItem[]
  viewMode: ViewMode
}

export function MovementsArea({
  arriving,
  departing,
  movements,
  viewMode,
  onRowClick,
  onCheckIn,
  onCheckOut,
  onRegister,
  onShowDetails,
}: MovementsAreaProps) {
  return (
    <div className="flex flex-col h-full min-h-0">
      {/* Content area — toggle is now in DayStrip */}
      <div className="flex-1 min-h-0">
        {viewMode === 'list' && (
          <EnhancedListView
            arriving={arriving}
            departing={departing}
            onRowClick={onRowClick}
            onCheckIn={onCheckIn}
            onCheckOut={onCheckOut}
            onRegister={onRegister}
            onShowDetails={onShowDetails}
          />
        )}
        {viewMode === 'dayflow' && (
          <DayFlowView
            movements={movements}
            onRowClick={onRowClick}
            onCheckIn={onCheckIn}
            onCheckOut={onCheckOut}
            onRegister={onRegister}
            onShowDetails={onShowDetails}
          />
        )}
        {viewMode === 'gantt' && (
          <GanttView
            movements={movements}
            onRowClick={onRowClick}
            onCheckIn={onCheckIn}
            onCheckOut={onCheckOut}
          />
        )}
      </div>
    </div>
  )
}
